module.exports = __webpack_public_path__ + "static/evenementenbeveiliging-910b950bf79dee8adb6e7e469367361b.png";